import React from 'react';

// Header Component
const Header = ({ logo }) => {
  return (
    <header className="bg-green-900 text-amber-100 p-4 shadow-md">
      <div className="container mx-auto flex items-center justify-center">
        <div className="flex flex-col items-center">
          <img 
            src={logo} 
            alt="Celtic Druid Irish Pub Logo" 
            className="w-60 h-20 mb-2"
          />
            <span className="block text-sm font-normal text-amber-200">Museo Digitale · 30° Anniversario</span>
        </div>
      </div>
    </header>
  );
};
export default Header;